module.exports = __webpack_public_path__ + "mer/fonts/iconfont.edf75d6a.eot";